import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/** The two top-level flows in Chunaav. */
export type Flow = 'admin' | 'user';

export interface AuthUser {
  name: string;
  email: string;
  role: string;
  flow: Flow;
}

interface AuthState {
  user: AuthUser | null;
}

const STORAGE_KEY = 'chunaav.auth';

function loadInitial(): AuthState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return { user: raw ? (JSON.parse(raw) as AuthUser) : null };
  } catch {
    return { user: null };
  }
}

const authSlice = createSlice({
  name: 'auth',
  initialState: loadInitial(),
  reducers: {
    loginSuccess(state, action: PayloadAction<AuthUser>) {
      state.user = action.payload;
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(action.payload));
      } catch {
        /* ignore persistence errors */
      }
    },
    logout(state) {
      state.user = null;
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {
        /* ignore */
      }
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
